import React from "react";
import "../css/privacy-policy.css";

const sections = [
  {
    title: "Overview",
    body: [
      "At Cling, we are deeply committed to the safety and well-being of every user, especially children. We maintain a zero-tolerance policy toward child sexual abuse material (CSAM), sexual exploitation, grooming, and any behavior that threatens the safety or dignity of minors.",
      "We design Cling’s community policies, reporting tools, and enforcement systems with a child protection-first mindset. Cling™ is a product of ClubIn Platforms Pvt. Ltd., an India-based company.",
    ],
  },
  {
    title: "Platform Restrictions and Age Limit",
    body: [
      "Cling is not intended for users under the age of 13.",
      "We currently allow only Food, Fashion & Beauty, Fresh & Organic, Fitness & Health, and Film & Fun businesses to register on the app. We do not allow other business account categories offering age-sensitive services.",
    ],
  },
  {
    title: "Prohibited Content and Behavior",
    bullets: [
      "sharing or posting child sexual abuse material in any form",
      "sexualized content, comments, or interactions directed at minors",
      "grooming, coercion, or attempts to establish inappropriate contact with minors",
      "any attempt to exploit, harass, or endanger children through Cling’s features",
    ],
    footer:
      "Violations may result in immediate account suspension, legal escalation, and cooperation with law enforcement authorities.",
  },
  {
    title: "Detection and Reporting Systems",
    bullets: [
      "content moderation to detect inappropriate imagery, keywords, and behavioral red flags",
      "reporting features that allow members to flag suspicious posts or users",
      "internal review workflows for flagged CSAE-related content",
    ],
  },
  {
    title: "Partnerships and Legal Compliance",
    body: [
      "All CSAE-related reports are documented, retained securely, and escalated to Indian law enforcement under applicable laws where required.",
    ],
  },
  {
    title: "Empowering the Community",
    body: [
      "Users can report abuse directly from posts, comments, or profiles. Reports are treated confidentially and prioritized with urgency.",
    ],
  },
  {
    title: "Contact and Escalation",
    body: [
      "If you suspect any form of child endangerment on Cling, contact us immediately at admin@clubinweb.in.",
    ],
  },
];

const PreventChildAbuse = () => {
  return (
    <div className="legal-document">
      <div className="legal-document__hero">
        <p className="legal-document__eyebrow">Child Safety</p>
        <h1>Cling’s Commitment to Preventing Child Sexual Abuse and Exploitation</h1>
        <p className="legal-document__lead">
          We maintain a mandatory, zero-tolerance stance on child sexual abuse and exploitation
          and continue to keep this section visible on the website as part of Cling’s safety
          commitments as operated by ClubIn Platforms Pvt. Ltd., an India-based company.
        </p>
      </div>

      <div className="legal-document__sections">
        {sections.map((section) => (
          <section className="legal-document__section" key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => (
              <p key={paragraph}>
                {paragraph.includes("admin@clubinweb.in") ? (
                  <>
                    If you suspect any form of child endangerment on Cling, contact us immediately
                    at <a href="mailto:admin@clubinweb.in">admin@clubinweb.in</a>.
                  </>
                ) : (
                  paragraph
                )}
              </p>
            ))}
            {section.bullets ? (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
            {section.footer ? <p>{section.footer}</p> : null}
          </section>
        ))}
      </div>
    </div>
  );
};

export default PreventChildAbuse;
